// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
// translate
import Translate from '../../language/Translate';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const getIcon2 = (name) => (
  <SvgIconStyle src={`/static/icons/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  kanban: getIcon('ic_kanban'),
  shield: getIcon2('shield'),
};

let sidebarConfigUser = [
    {
      subheader: Translate('MANAGEMENT'),
      items: [
        {
          title: Translate('User'),
          path: PATH_DASHBOARD.user.root,
          icon: ICONS.user
        },
        {
          title: Translate('Messages'),
          path: PATH_DASHBOARD.user.messages,
          icon: ICONS.mail
        },
      ]
    },
  ];  

let sidebarConfigAdmin = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: Translate("GENERAL"),
      items: [
        { title: Translate("App"), path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
        { title: Translate("Users"), path: PATH_DASHBOARD.general.users, icon: ICONS.user },
        { title: Translate("Vacancies"), path: PATH_DASHBOARD.general.vacancies, icon: ICONS.analytics },
        { title: Translate("Mailing list"), path: PATH_DASHBOARD.general.messages, icon: ICONS.mail },
        { title: Translate("Video Template"), path: PATH_DASHBOARD.general.video_template, icon: ICONS.shield },
      ]
    }
  ];  

export { sidebarConfigUser, sidebarConfigAdmin };
